import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  children: any;
  fromTop: number;
}

function NavigationDropdownContent({ children, fromTop }: Props) {
  return <DropdownContent fromTop={fromTop}>{children}</DropdownContent>;
}

const DropdownContent = styled(FlexRow)`
  position: absolute;
  top: ${(props: { fromTop: number }) => rem(props.fromTop)};
  z-index: 400;
  cursor: initial;

  &:hover {
    display: block;
  }
`;

export { NavigationDropdownContent as DsiNavigationDropdownContent };
